import {
  Grid,
  TextField,
  Box,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  FormHelperText,
  Typography,
  InputAdornment,
  IconButton,
} from "@mui/material";
import { React, useRef, useEffect, useState, useMemo } from "react";

import BluePrimaryButton from "../../common/button/bluePrimaryButton";
import BackButton from "../../common/button/backButton";

import Cookies from "js-cookie";
import { useLocation, useNavigate } from "react-router-dom";
import { Controller, useForm } from "react-hook-form";

import { useDispatch, useSelector } from "react-redux";
import masterFormsActions from "../../redux/masterForms/actions";
import masterActions from "../../redux/master/actions";
import { MdVisibility, MdVisibilityOff } from "react-icons/md";
import { DecryptFunction } from "../../utils/cryptoFunction";

export default function AddObjection() {
  const navigate = useNavigate();
  const location = useLocation();
  let id = location?.state?.id;
  const dispatch = useDispatch();
  const [showPassword, setShowPassword] = useState(false);

  const { driveList } = useSelector((state) => state.masterFormsReducer);
  const { courseList } = useSelector((state) => state.masterReducer);
  const { courseCategoryList } = useSelector((state) => state.masterFormsReducer);
 const { objectionList } = useSelector((state) => state.masterReducer);
  
  const { backofficeTokenDetails } = useSelector((state) => state.authReducer);

  const {
    register,
    handleSubmit,
    watch,
    setValue,
    getValues,
    reset,
    trigger,
    control,
    setError,
    resetField,
    formState: { errors },
  } = useForm();

  useEffect(() => {
    dispatch({ type: masterActions.GET_COURSE_LIST });
    dispatch({ type: masterActions.GET_OJECTION_LIST });
  }, []);

  useEffect(() => {
    dispatch({ type: masterFormsActions.GET_DRIVE });
    dispatch({ type: masterFormsActions.GET_COURSECATEGORY });

    if (location.search === "?page=updateobjection") {
      dispatch({
        type: masterActions.GET_OJECTION_LIST,
      });
    }
  }, []);

useEffect(() => {
  if (id && objectionList?.data?.length > 0) {
    let data = objectionList?.data.find(
      (obj) => obj.objectiontrackerid == id
    );

    if (data) {

    const decryptedPassword = data.password ? DecryptFunction(data.password) : "";

      reset({
        coursedriveid: data.coursedriveid?.toString(),
        coursecategoryid: data.coursecategoryid?.toString(),
        courseid: data.courseid?.toString(),
        emailid: data.emailid || "",
        password: decryptedPassword || "",
        projectname: data.projectname || "",
        status: data.status === 1
      });
    }
  }
}, [objectionList, id, reset]);

  const resetForm = () => {
    setValue("coursedriveid", "");
    setValue("coursecategoryid", "");
    setValue("courseid", "");
    setValue("emailid", "");
    setValue("password", "");
    setValue("projectname", "");


    reset({
      coursedriveid: "",
      coursecategoryid: "",
      courseid: "",
      emailid: "",
      password: "",
      projectname: "",
      status: "",
    });
  };

  const selectedCategoryId = watch("coursecategoryid");

  const filteredCourses = useMemo(() => {
    return (
      courseList?.all?.filter(
        (course) =>
          course.coursecategoryid?.toString() === selectedCategoryId?.toString()
      ) || []
    );
  }, [courseList, selectedCategoryId]);

  const handleAddObjection = (data) => {
    data["userid"] = backofficeTokenDetails?.id;

    data["coursecategoryid"] = parseInt(data.coursecategoryid);
    data["coursedriveid"] = parseInt(data.coursedriveid);
    data["courseid"] = parseInt(data.courseid);
    data["status"] = "1";


    dispatch({
      type: masterActions.CREATE_OJECTION_LIST,
      payload: { data: data, navigate: navigate, resetForm: resetForm },
    });
  };
  const handleUpdateObjection = (data) => {
    data["userid"] = backofficeTokenDetails?.id;
    data["coursecategoryid"] = parseInt(data.coursecategoryid);
    data["coursedriveid"] = parseInt(data.coursedriveid);
    data["courseid"] = parseInt(data.courseid);
    data["status"] = "1";

    dispatch({
      type: masterActions.UPDATE_OJECTION_LIST,
      payload: { data: data, id: id, navigate: navigate, resetForm: resetForm },
    });
  };

  const handleClickShowPassword = () => {
    setShowPassword(!showPassword);
  };

  return (
    <>
      <Grid container spacing={4} mb={3}>
        <Grid item xs={12} sm={12} md={6}>
          <Box
            sx={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              gap: 2,
            }}
          >
            <FormControl error={!!errors.coursedriveid} fullWidth>
              <InputLabel htmlFor="coursedriveid">
                <span>
                  Select Course Drive
                  <span className="error" style={{ color: "red" }}>
                    *
                  </span>
                </span>
              </InputLabel>
              <Controller
                name="coursedriveid"
                control={control}
                defaultValue="" 
                rules={{ required: "Drive Name is required" }} 
                helperText={errors?.coursedriveid?.message}
                FormHelperTextProps={{
                  style: { margin: 0 },
                }}
                error={!!errors.coursedriveid}
                render={({ field }) => (
                  <Select
                    {...field}
                    label={
                      <span>
                        Select Course Drive
                        <span className="error" style={{ color: "red" }}>
                          *
                        </span>
                      </span>
                    }
                    labelId="coursedriveid"
                    id="coursedriveid"
                    error={!!errors.coursedriveid}
                    helperText={errors.coursedriveid?.message}
                    size="medium"
                  >
                    <MenuItem value="" disabled>
                      Select Drive Name
                    </MenuItem>
                    {driveList?.all.map((obj, i) => (
                      <MenuItem
                        key={obj.driveid.toString()}
                        value={obj.driveid.toString()}
                      >
                        {obj.drivename}
                      </MenuItem>
                    ))}
                  </Select>
                )}
              />
            </FormControl>
          </Box>
          <FormHelperText style={{ margin: 0, color: "#d32f2f" }}>
            {errors?.coursedriveid?.message}
          </FormHelperText>
        </Grid>

        <Grid item xs={12} md={6}>
          <FormControl error={!!errors.coursecategoryid} fullWidth>
            <InputLabel htmlFor="coursecategoryid">
              <span>
                Select Course Category
                <span className="error" style={{ color: "red" }}>
                  *
                </span>
              </span>
            </InputLabel>
            <Controller
              name="coursecategoryid"
              id="demo-simple-select"
              helperText={errors?.coursecategoryid?.message}
              FormHelperTextProps={{
                style: { margin: 0 },
              }}
              error={!!errors.coursecategoryid}
              rules={{ required: "Course Category is required" }}
              control={control}
              defaultValue="" 
              render={({ field }) => (
                <Select
                  size="medium"
                  fullWidth
                  label={
                    <span>
                      Select Course Category
                      <span className="error" style={{ color: "red" }}>
                        *
                      </span>
                    </span>
                  }
                  {...field}
                  error={!!errors.coursecategoryid}
                  helperText={errors.coursecategoryid?.message}
                  FormHelperTextProps={{
                    style: { margin: 0 },
                  }}
                >
                  <MenuItem key="" value="" disabled>
                    Select Course Category
                  </MenuItem>

                  {courseCategoryList &&
                    courseCategoryList?.all.map((obj) => {
                      return (
                        <MenuItem
                          key={obj.coursecategoryid.toString()}
                          value={obj.coursecategoryid.toString()}
                        >
                          {obj.coursecategory}
                        </MenuItem>
                      );
                    })}
                </Select>
              )}
            />
          </FormControl>
          <FormHelperText style={{ margin: 0, color: "#d32f2f" }}>
            {errors?.coursecategoryid?.message}
          </FormHelperText>
        </Grid>

        <Grid item xs={12} md={6}>
          <FormControl error={!!errors.courseid} fullWidth>
            <InputLabel htmlFor="courseid">
              <span>
                Select Course
                <span className="error" style={{ color: "red" }}>
                  *
                </span>
              </span>
            </InputLabel>
            <Controller
              name="courseid"
              id="demo-simple-select"
              helperText={errors?.courseid?.message}
              FormHelperTextProps={{
                style: { margin: 0 },
              }}
              error={!!errors.courseid}
              rules={{ required: "Course Category is required" }}
              control={control}
              defaultValue=""
              render={({ field }) => (
                <Select
                  size="medium"
                  fullWidth
                  label={
                    <span>
                      Select Course
                      <span className="error" style={{ color: "red" }}>
                        *
                      </span>
                    </span>
                  }
                  {...field}
                  error={!!errors.courseid}
                  helperText={errors.courseid?.message}
                  FormHelperTextProps={{
                    style: { margin: 0 },
                  }}
                >
                  <MenuItem key="" value="" disabled>
                    Select Course
                  </MenuItem>

                  {filteredCourses?.map((obj) => (
                    <MenuItem
                      key={obj.courseid.toString()}
                      value={obj.courseid.toString()}
                    >
                      {obj.coursename}
                    </MenuItem>
                  ))}
                </Select>
              )}
            />
          </FormControl>
          <FormHelperText style={{ margin: 0, color: "#d32f2f" }}>
            {errors?.courseid?.message}
          </FormHelperText>
        </Grid>

        <Grid item xs={12} md={6}>
          <TextField
            {...register("emailid", {
              required: "emailid is required",
            })}
            InputLabelProps={{
              shrink: !!watch("emailid"),
            }}
            error={!!errors.emailid}
            helperText={errors.emailid?.message}
            FormHelperTextProps={{
              style: { margin: 0 },
            }}
            size="medium"
            fullWidth
            label={
              <span>
                Email Id
                <span className="error" style={{ color: "red" }}>
                  *
                </span>
              </span>
            }
          />
        </Grid>

        <Grid item xs={12} md={6}>
          <TextField
            {...register("password", {
              required: "Password is required",
              minLength: {
                value: 8,
                message: "Password must be at least 8 characters",
              },
            })}
            InputLabelProps={{
              shrink: !!watch("password"),
            }}
            error={!!errors.password}
            helperText={errors.password?.message}
            FormHelperTextProps={{
              style: { margin: 0 },
            }}
            size="medium"
            fullWidth
            type={showPassword ? "text" : "password"}
            InputProps={{
              endAdornment: (
                <InputAdornment position="end">
                  <IconButton
                    aria-label="toggle password visibility"
                    onClick={handleClickShowPassword}
                    edge="end"
                  >
                    {showPassword ? <MdVisibilityOff /> : <MdVisibility />}
                  </IconButton>
                </InputAdornment>
              ),
            }}
            label={
              <span>
                Enter Password
                <span className="error" style={{ color: "red" }}>
                  *
                </span>
              </span>
            }
          />
        </Grid>

        <Grid item xs={12} md={6}>
          <TextField
            {...register("projectname", {
              required: "Project Name is required",
            })}
            InputLabelProps={{
              shrink: !!watch("projectname"),
            }}
            error={!!errors.projectname}
            helperText={errors.projectname?.message}
            FormHelperTextProps={{
              style: { margin: 0 },
            }}
            size="medium"
            fullWidth
            label={
              <span>
                Project Name
                <span className="error" style={{ color: "red" }}>
                  *
                </span>
              </span>
            }
          />
        </Grid>
      </Grid>

      <Grid container spacing={3} mb={3}>
        <Grid
          item
          md={12}
          sx={{ display: "flex", justifyContent: "flex-end", gap: "8px" }}
        >
          <BackButton
            handleBack={() =>
              navigate(
                `/${Cookies.get(
                  "mhet_mst_project"
                )}/objection-management?page=objectionlist`
              )
            }
          />
          <BluePrimaryButton
            handleSubmit={handleSubmit(
              location.search !== "?page=updateobjection"
                ? handleAddObjection
                : handleUpdateObjection
            )}
            title={
              location.search === "?page=updateobjection" ? "Update" : "Submit"
            }
          />
        </Grid>
      </Grid>
    </>
  );
}
